import { createAction, props } from "@ngrx/store";
import { IChatUserInfoData } from "./chatUserInfo.state";

export const updateChatUserInfoData = createAction(
    '[Chat User Infos] Update User Info Data',
    props<{
        userId: string;
        chatUserInfoData: IChatUserInfoData;
    }>()
);

export const clearChatUserInfoData = createAction(
    '[Chat User Infos] Clear User Info Data',
    props<{
        userId: string;
    }>()
);
